






































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import PermintaanPatologiAnatomiInputModal from "@/components/modal/PermintaanPatologiAnatomiInputModal.vue";
import { storePermintaanPatologiAnatomi } from "@/store/modules/PermintaanPatologiAnatomiStore";
import PermintaanPatologiAnatomiSvc from "@/services/PermintaanPatologiAnatomi";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: {
    CardModalTtd,
    PermintaanPatologiAnatomiInputModal
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardPermintaanPatologiAnatomi extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  modalInput = false;
  modalTtd = false;
  modalLabPa = false;
  editData: any = null;
  signItem: any = null;
  labPaItem: any = null;
  labPaForm = { no_pa: "", cocokan_ok_nama: "", cocokan_lab_nama: "" };
  deleting = false;
  savingLab = false;

  mounted() {
    this.reload();
  }

  reload() {
    if (this.register) {
      storePermintaanPatologiAnatomi.getByRegister(this.register);
    }
  }

  get items() {
    return storePermintaanPatologiAnatomi.items;
  }

  get loading() {
    return storePermintaanPatologiAnatomi.loading;
  }

  get stateuser() {
    return userModule.user;
  }

  get canMake() {
    const profesi = (this.stateuser.profesi || "").toLowerCase();
    return ["dokter", "perawat", "bidan"].includes(profesi);
  }

  get canIsiLab() {
    const profesi = (this.stateuser.profesi || "").toLowerCase();
    const unit = (this.stateuser.unit || "").toLowerCase();
    return profesi.includes("analis") || unit.includes("lab") || unit.includes("patologi");
  }

  canEdit(item) {
    if (!this.canMake) return false;
    return !item.dokter_pengirim || item.dokter_pengirim.id == this.stateuser.id;
  }

  tooltipTtd(item) {
    if (this.canSignItem(item)) return "Tandatangani sebagai Dokter Pengirim";
    if (!item.dokter_pengirim) return "Dokter pengirim belum dipilih — ubah permintaan lalu pilih dokter pengirim";
    return `Menunggu tanda tangan ${item.dokter_pengirim.nama || "dokter pengirim"} — hanya akun tersebut yang dapat menandatangani`;
  }

  canSignItem(item) {
    return (
      !item.signed_pengirim &&
      item.dokter_pengirim &&
      this.stateuser.id == item.dokter_pengirim.id
    );
  }

  labelJenis(j: string) {
    const map: Record<string, string> = {
      histologi: "Histologi",
      ajh: "AJH (FNAC)",
      sitologi_cairan: "Sitologi Cairan",
      pap_smear: "Pap Smear",
      sitologi_swab: "Sitologi Swab",
      imunohistokimia: "Imunohistokimia"
    };
    return map[j] || j;
  }

  labelLateralisasi(s: string) {
    const map: Record<string, string> = {
      kanan: "Kanan",
      kiri: "Kiri",
      bilateral: "Bilateral"
    };
    return map[s] || s;
  }

  formatDate(date: string | null) {
    return date ? getHumanDateTime(date) : "-";
  }

  openInput(item: any) {
    if (this.readOnly) return;
    this.editData = item;
    this.modalInput = true;
  }

  openSign(item: any) {
    this.signItem = item;
    this.modalTtd = true;
  }

  openLabPa(item: any) {
    this.labPaItem = item;
    this.labPaForm = {
      no_pa: item.no_pa || "",
      cocokan_ok_nama: item.cocokan_ok_nama || "",
      cocokan_lab_nama: item.cocokan_lab_nama || ""
    };
    this.modalLabPa = true;
  }

  async saveLabPa() {
    if (!this.labPaItem || !this.labPaForm.no_pa) {
      alert("NO. PA wajib diisi");
      return;
    }
    this.savingLab = true;
    try {
      const resp = await PermintaanPatologiAnatomiSvc.updateLabPa(this.labPaItem.id, this.labPaForm);
      if (resp.data.status == "1") {
        appModule.NoticeDelay("NO. PA & verifikasi cocokan disimpan");
        this.modalLabPa = false;
        this.reload();
      }
    } finally {
      this.savingLab = false;
    }
  }

  async passTtd(password: string) {
    if (!this.signItem) return;
    const resp = await PermintaanPatologiAnatomiSvc.signPengirim(this.signItem.id, { password });
    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay("Berhasil Tanda Tangan Permintaan PA");
      appModule.addMsgTtd("");
      this.reload();
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  onSaved() {
    this.reload();
  }

  print(item: any) {
    PermintaanPatologiAnatomiSvc.print(item.id);
  }

  async remove(item: any) {
    if (!confirm("Anda yakin akan menghapus Permintaan PA ini?")) return;
    if (this.deleting) return;
    this.deleting = true;
    try {
      const resp = await PermintaanPatologiAnatomiSvc.destroy(item.id);
      if (resp?.status == "1" || resp?.status == 1) {
        appModule.NoticeDelay(resp.message || "Berhasil menghapus");
        this.reload();
      }
    } finally {
      this.deleting = false;
    }
  }
}
